export const AUTOMATED_OVERRIDDING_RISKFACTOR_LIST = 'src/components/RiskFactor/OverriddingRiskFactor/List/action/Automated_Overridding_RiskFactor_List';
export const AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_SUCCESS = 'src/components/RiskFactor/OverriddingRiskFactor/List/action/Automated_Overridding_RiskFactor_List_Success';
export const AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_FAILURE = 'src/components/RiskFactor/OverriddingRiskFactor/List/action/Automated_Overridding_RiskFactor_List_Failure';

export const automatedOverriddingRiskFactorList = () => {
    return {
        type: AUTOMATED_OVERRIDDING_RISKFACTOR_LIST,
    }
}
export const automatedOverriddingRiskFactorListSuccess = (data) => {
    return {
        type: AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_SUCCESS,
        data
    }
}
export const automatedOverriddingRiskFactorListFailure = (data) => {
    return {
        type: AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_FAILURE,
        data
    }
}